export const dataHooks = {
    tickerUp: 'ticker-up-button',
    tickerDown: 'ticker-down-button',
};
//# sourceMappingURL=constants.js.map